import apiConfig from "../config/apiConfig";
import { apiFetch } from "../apis/apiFetch";
import {
  BTechNumericApplicationKeys,
} from "../config/btechApplicationFields";

function utf8ToBase64Json(obj: Record<string, unknown>): string {
  const jsonString = JSON.stringify(obj);
  return btoa(
    encodeURIComponent(jsonString).replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode(parseInt(p1, 16)),
    ),
  );
}

/** Build FormData for POST applications (matches graduation / programme save behaviour). */
export function applicationPayloadToFormData(
  payload: Record<string, unknown>,
  options?: { userIdForDms?: string },
): FormData {
  const params = new FormData();
  const p: Record<string, unknown> = { ...payload };

  for (const key of BTechNumericApplicationKeys) {
    if (p[key] === "" || p[key] === undefined) continue;
    const n = Number(p[key]);
    if (!Number.isNaN(n)) p[key] = n;
  }

  const fileKeys = Object.keys(p).filter((k) => p[k] instanceof File);
  for (const key of fileKeys) {
    params.append(key, p[key] as File);
    p[key] = "";
  }

  if (fileKeys.length > 0) {
    params.append("description", "application");
    params.append("appId", "admission-portal");
    params.append("dmsRole", "admin");
    params.append("user_id", options?.userIdForDms || "admin@rasp.com");
    params.append("tags", "application,upload");
  }

  if (p.id) params.append("action", "MODIFY");

  params.append("resource", utf8ToBase64Json(p as Record<string, unknown>));
  return params;
}

export async function saveApplicationRecord(
  payload: Record<string, unknown>,
  options?: { userIdForDms?: string },
) {
  const params = applicationPayloadToFormData(payload, options);
  const res = await apiFetch(apiConfig.getResourceUrl("applications"), {
    method: "POST",
    body: params,
  });
  return res.json();
}
